module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Schoil Mhuire Milford","short_name":"Scoil Mhuire","start_url":"/","background_color":"#38409a","theme_color":"#38409a","icon":"src/images/crest.svg","display":"minimal-ui","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"53bc0221d61cfb2919d0df836f24247f"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
